import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-ag-select-renderer',
  template: `
    <select [value]="value" disabled>
      <option value="AN">AND</option>
      <option value="OR">OR</option>
    </select>
  `
})
export class AgSelectRendererComponent implements ICellRendererAngularComp {
  private params: any;
  value: string = '';

  agInit(params: any): void {
    this.params = params;
    this.value = params.value;
  }

  refresh(params: any): boolean {
    this.value = params.value;
    return true;
  }

  onChange(event: any) {
    const newValue = event.target.value;
    this.value = newValue;
    this.params.node.setDataValue(this.params.colDef.field, newValue);
  }
}
